import { RootNode } from "@strapi/blocks-react-renderer/dist/BlocksRenderer";

export type Announcement = {
	documentId: string;
	title: string;
	pages: Page[];
};

type Page = {
	id?: string | number;
	imageUrl?: string;
	title: string;
	description: RootNode[];
	ctaLabel: string;
	shortCtaLabel: string;
	backgroundColor: string;
};

export type FeaturePreview = Omit<Announcement, "documentId">;

export const isAnnouncement = (content: Announcement | FeaturePreview): content is Announcement =>
	"documentId" in content;

export const createParagraphBlock = (text: string): RootNode[] => [
	{
		type: "paragraph",
		children: [
			{
				type: "text",
				text,
			},
		],
	},
];
